import { useSelectionArchiveStore } from '@stores/useSelectionArchiveStore';

export const refuseProposalButton = (button) => button.addEventListener(
  'click',
  () => useSelectionArchiveStore().openArchiveModal(Number(button.dataset.selectionItemId)),
);
